import type { ComponentProps } from 'react';
import React, { Fragment, useCallback, useState } from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { t } from 'Src/i18n';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { Title } from 'Components/frameworks/title/Title';
import { TermsAndConditions } from 'Components/widgets/payment-info/payment-form/TermsAndConditions';
import { PaymentPlan } from 'Components/widgets/payment-info/payment-form/PaymentPlan';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { useAppContext } from 'Context/ReactAppContext';
import { useFormikContext } from 'formik';
import type { PaymentFormValues } from 'Src/types/payment';
import { useDispatch } from 'react-redux';
import { useBookingNavbar } from 'Components/widgets/booking-navbar/useBookingNavbar';
import { startLoading } from 'Store/global-loader/globalLoader.action';
import { asComponentProps } from 'Src/types/cast-helpers';
type Props = {
  i18n: I18N;
  paymentSchedules: Array<PaymentSchedule>;
};
export const DelCrederePaymentForm = ({ i18n, paymentSchedules = [] }: Props) => {
  const appContext = useAppContext();
  const formik = useFormikContext<PaymentFormValues>();
  const {
    termsAndConditions: { cgv },
  } = formik.values;
  const [isCmtaContinueButtonDisabled, setIsCmtaContinueButtonDisabled] = useState(false);
  const dispatch = useDispatch();
  const validationCallback = useCallback(() => {
    if (appContext.isCmta && !!cgv) {
      setIsCmtaContinueButtonDisabled(true);
      dispatch(startLoading());
    }

    formik.submitForm();
    return Promise.reject();
  }, [appContext.isCmta, cgv, dispatch, formik.submitForm]);
  useBookingNavbar({
    validationCallback,
    isPriceLoading: isCmtaContinueButtonDisabled,
    isDisabled: !cgv,
  });
  return (
    <Fragment>
      <Title
        {...asComponentProps<ComponentProps<typeof Title>>({
          className: 'mb-10',
          color: COLORS.BLUE_WAVE,
          theme: 'title-brand-n2',
        })}
      >
        {t('booking.banking.pageTitle')}
      </Title>
      <Capsule className="mb-20" header="none">
        <p className="reset-paragraph px-20 py-25 text-14 leading-1">
          {t('booking.partners.payment.ducroire')}
        </p>
      </Capsule>

      {isFeatureFlipped(appContext)('booking.cmta.PaymentScheduleDucroire')
        ? paymentSchedules.map((paymentSchedule, index) => {
            return (
              paymentSchedule?.repaymentSchedules?.length > 0 && (
                <PaymentPlan key={index} paymentSchedule={paymentSchedule} />
              )
            );
          })
        : null}

      <TermsAndConditions
        i18n={i18n}
        isDisabled={false}
        shouldDisplayDonationTerms={false}
        shouldSubmitFormOnAccept={false}
      />
    </Fragment>
  );
};
